import { useBranding, logoLogin } from '../context/BrandingContext';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Send, ArrowLeft, MailCheck } from 'lucide-react';
import { authAPI } from '../services/api';

const RecuperarSenha = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const navigate = useNavigate();
  const { branding } = useBranding();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.recuperarSenha(email);
    } catch (error) {
      // De proposito nao tratamos o erro de forma diferente: o backend nao
      // revela se o e-mail existe, e a tela segue a mesma orientacao.
    }
    setEnviado(true);
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src={logoLogin(branding)}
          alt={branding.nome}
          style={{ height: '80px', marginBottom: '1rem', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        />
        <p style={{ textAlign: 'center', color: 'var(--gray-600)', marginBottom: '1.5rem' }}>Recuperar senha</p>

        {enviado ? (
          <>
            <div
              className="alert"
              style={{ background: '#eafaf1', color: '#1e8449', border: '1px solid #a9dfbf', display: 'flex', gap: '0.6rem', alignItems: 'flex-start' }}
            >
              <MailCheck size={20} style={{ flexShrink: 0, marginTop: '2px' }} />
              {/* A saida final ("procure o administrador") e o que faltava: sem
                  ela, quem NAO esta cadastrado fica reenviando o pedido sem
                  entender por que nada chega. Segue sem revelar se o e-mail
                  existe: isso e proposital (anti-enumeracao). */}
              <span>
                Se o e-mail estiver cadastrado, o link de redefinição chega em alguns
                minutos. Ele expira em 1 hora.{' '}
                <strong>
                  Não chegou? Verifique o spam ou fale com o administrador.
                </strong>
              </span>
            </div>
            <button className="btn btn-primary btn-block" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }}>
              <ArrowLeft size={18} /> Voltar ao login
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: 'var(--gray-600)', fontSize: '0.9rem', marginBottom: '1rem' }}>
              Informe o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.
            </p>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
              />
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Enviando...' : (<><Send size={18} /> Enviar link</>)}
            </button>

            <div style={{ textAlign: 'center', marginTop: '0.85rem' }}>
              <button
                type="button"
                onClick={() => navigate('/login')}
                style={{ background: 'none', border: 'none', color: 'var(--gray-600)', cursor: 'pointer', fontSize: '0.88rem', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', padding: 0 }}
              >
                <ArrowLeft size={15} /> Voltar ao login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default RecuperarSenha;
